import type { VideoModelConfig } from '../../types';

/** Wan3.0 Prime（与 Wan3.0 行为一致） */
export const wan3_0Prime: VideoModelConfig = {
  id: '01M1ZQZ0A1YC40TCZ2E86YD5NM',
  displayName: 'Wan3.0 Prime',
  defaults: {
    ratio: '9:16',
    resolution: '720P',
    duration: 5,
    sound: 'on',
  },
  ratioOptions: [
    { label: '1:1', value: '1:1' },
    { label: '3:4', value: '3:4' },
    { label: '4:3', value: '4:3' },
    { label: '9:16', value: '9:16' },
    { label: '16:9', value: '16:9' },
  ],
  resolutionOptions: [
    { label: '480P', value: '480P' },
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'range', min: 2, max: 30, step: 1, default: 5 },
  capabilities: {
    refVideo: true,
    refAudio: true,
    refDoc: true,
    sound: true,
    multiModalReference: true,
    multiVideo: true,
  },
  limits: {
    promptMaxLength: 20000,
    maxRefImages: 10,
    maxRefVideos: 5,
    maxRefAudios: 5,
    // 参考文档个数上限（前端自维护：后端 field_map 暂无 ref_docs 字段，原代码默认 5 转正）
    maxRefDocs: 5,
    // 参考视频上传约束（转写自 VideoSelectModal 原硬编码）：格式 mp4/mov、单文件 ≤100MB、时长 [2,15]s、总时长 ≤15s
    refVideoConstraints: {
      formats: ['mp4', 'mov'],
      maxFileSizeMB: 100,
      duration: { min: 2, max: 15, totalMax: 15 },
      hintKey: 'imageCreation.videoUploadHintWan30',
    },
    // 参考音频上传约束（转写自 AudioSelectModal 原硬编码）：格式 wav/mp3、单文件 ≤15MB、时长 [1,15]s
    refAudioConstraints: {
      formats: ['wav', 'mp3'],
      maxFileSizeMB: 15,
      duration: { min: 1, max: 15 },
      hintKey: 'imageCreation.audioUploadHintWan30',
    },
  },
  /** 画布扩展（节点式业务专属字段，从画布 configs/wan-3.0-prime.ts 迁移） */
  canvas: {
    defaults: {
      audioSync: true,
    },
    toggles: {
      audioSync: true,
    },
    durationExt: {
      integerOnly: true,
      combinedMaxWithRefVideo: 30,
    },
    capabilities: {
      refVideo: true,
      refAudio: true,
      atMentionTabs: ['全能参考', '图生视频', '视频编辑', '视频延长'],
    },
    limits: {
      validateRefImageSize: true,
      promptMaxLength: 5000,
      maxRefImages: 10,
      maxRefVideos: 5,
      maxRefAudios: 5,
      maxAllRefTotal: 20,
      refImageConstraints: {
        formats: ['jpg', 'jpeg', 'png', 'webp', 'bmp'],
        maxFileSizeMB: 20,
        dimension: { min: 240, max: 8000 },
        aspectRatio: { min: 0.125, max: 8 },
      },
      refVideoConstraints: {
        formats: ['mp4', 'mov'],
        maxFileSizeMB: 100,
        duration: { min: 2, max: 15, totalMax: 15 },
        dimension: { min: 240, max: 4096 },
        aspectRatio: { min: 0.125, max: 8 },
      },
      refAudioConstraints: {
        formats: ['wav', 'mp3'],
        maxFileSizeMB: 15,
        duration: { min: 1, max: 15, totalMax: 15 },
      },
    },
    refMedia: [
      { type: 'doc', label: '文档', labelKey: 'canvas.video.panel.doc', max: 1, formats: ['docx', 'doc', 'xlsx', 'xls', 'pptx', 'ppt', 'pdf', 'txt', 'key', 'pages', 'numbers', 'md'], maxFileSizeMB: 20, tabs: ['全能参考'] },
      { type: 'link', label: '链接', labelKey: 'canvas.video.panel.link', max: 1, tabs: ['全能参考'] },
    ],
  },
};
